/**
 * 商品期货顶部基本信息
 */
import React from "react"
import { store } from "./store"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { Observer } from "mobx-react-lite"
import { LoadMore } from "../../shared/quote_load_more"
import { ChartType } from "../../shared/utils"

export function SPQHBasicInfo() {
  return (
    <Observer>
      {() => (
        <div className="datas">
          <div className="top-p">
            <div>
              <p className="stock-value">{store.chart_mouse_move_data ? quote_chart[quote_item_name.最新价](store.chart_mouse_move_data.newPrice, store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.最新价](store.StockDetail).option_element}</p>
              <p>
                {store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌幅](store.chart_mouse_move_data.zdf, store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.涨跌幅](store.StockDetail).option_element}
                {store.chart_mouse_move_data ? quote_chart[quote_item_name.涨跌额](store.chart_mouse_move_data.zde).element : single_quote[quote_item_name.涨跌额](store.StockDetail).option_element}
              </p>
            </div>
            <div>
              <div className="row">
                {store.chartType != ChartType.分时 && store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>今开</span>
                      {quote_chart[quote_item_name.今开](store.chart_mouse_move_data.jinkai, store.chart_mouse_move_data.jkColor).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {quote_chart[quote_item_name.最高](store.chart_mouse_move_data.maxPrice, store.chart_mouse_move_data.maxPriceColor).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {quote_chart[quote_item_name.最低](store.chart_mouse_move_data.minPrice, store.chart_mouse_move_data.minPriceColor).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>今开</span>
                      {single_quote[quote_item_name.今开](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {single_quote[quote_item_name.最高](store.StockDetail).option_element}
                    </p>
                    <p>
                      <span>最低</span>
                      {single_quote[quote_item_name.最低](store.StockDetail).option_element}
                    </p>
                  </>
                )}
              </div>
              <div className="row">
                {store.chartType != ChartType.分时 && store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>总手</span>
                      {quote_chart[quote_item_name.总手](store.chart_mouse_move_data.zongshou).element}
                    </p>
                    <p>
                      <span>持仓</span>
                      {quote_chart[quote_item_name.持仓](store.chart_mouse_move_data.chicang).element}
                    </p>
                    <p>
                      <span>日增</span>
                      {quote_chart[quote_item_name.日增](store.chart_mouse_move_data.rizeng,store.chart_mouse_move_data.rizengColor).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>总手</span>
                      {single_quote[quote_item_name.总手](store.StockDetail).element}
                    </p>
                    <p>
                      <span>持仓</span>
                      {single_quote[quote_item_name.持仓](store.StockDetail).element}
                    </p>
                    <p>
                      <span>日增</span>
                      {single_quote[quote_item_name.日增](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-p">
            {store.chartType != ChartType.分时 && store.chart_mouse_move_data ? (
              <>
                <p>
                  <span>结算</span>
                  {quote_chart[quote_item_name.结算](store.chart_mouse_move_data.jiesuan).element}
                </p>
                <p>
                  <span>昨结</span>
                  {quote_chart[quote_item_name.昨结](store.chart_mouse_move_data.zuojie).element}
                </p>
                <p><span></span><span></span></p>
              </>
            ) : (
              <>
                <p>
                  <span>结算</span>
                  {single_quote[quote_item_name.结算](store.StockDetail).element}
                </p>
                <p>
                  <span>昨结</span>
                  {single_quote[quote_item_name.昨结](store.StockDetail).element}
                </p>
                <p><span></span><span></span></p>
              </>
            )}
            <LoadMore />
          </div>
        </div>
      )}
    </Observer>
  )
}
